import React, { useEffect, useState } from 'react'
import { useForm } from '../../../hooks/ useForm'
import PreguntaComponent from './PreguntaComponent'
import Loading from '../../tools/Loading'
import MessageAlert from '../../tools/MessageAlert'
import { addQuestion } from '../../../helpers/contenido'
import { useDispatch } from 'react-redux'
import { newQuestion } from '../../../reducer/ContenidoReducer'
const Preguntas = ({data,email, idAsig, idTema}) => {
    const dispatch = useDispatch()
    const [value, handleInputChange, reset] = useForm({question: ''})
    const [error, setError] = useState(false)
    const [message, setMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const {question} = value;

    const handleSubmit = () => {
        
        if (isFormValid()) {
            setLoading(true)
            addQuestion(email,idAsig,idTema,question)
            .then(response => {
                dispatch(newQuestion(response.id, '¿'+question+'?'))
                setLoading(false)
                reset()
            })
        }
    }


    const isFormValid = ( ) =>{
        if (question.trim().length === 0) {
            setError(true)
            setMessage('Pregunta requerida')
            return false
        }
        return true;
    }

    useEffect(() => {
        setTimeout(() => {
            setError(false)
            setMessage('')
        },10000)
        return () => {
            setError(false)
            setMessage('')
        }
    }, [error])

    return (
        <div className='sec5'>
            <div className='cont_add_pregunta'>
                <input 
                    type='text' name='question' value={question} onChange={handleInputChange}
                    placeholder='Pregunta'
                />

                {
                    loading
                    ? <Loading />
                    :
                        error
                        ?  <>
                                <MessageAlert alert='dan' msg={message} mrb={'0%'} />
                                <i className='fas fa-plus' onClick={handleSubmit}></i>
                            </>
                        :<i className='fas fa-plus' onClick={handleSubmit}></i>
                }
                
            </div>
            <div className='cards_question'>
                {
                    data.length === 0
                    ?   <span>No hay Preguntas</span>
                    :
                    data.map(query => (
                        <PreguntaComponent key={query.id} data={query} email={email} idAsig={idAsig} idTema={idTema}/>
                    ))
                }
            </div>
        </div>
    )
}

export default Preguntas
